import { VIEW_MODE_STORAGE_KEY, localStorage } from './constants';
import { VIEW_MODE_DEFAULT, type ViewModeType } from './types';

export const getViewModeFromLocalStorage = (): ViewModeType =>
	localStorage.get(VIEW_MODE_STORAGE_KEY) || VIEW_MODE_DEFAULT;
